// Formato de valores de parámetros legales según su unidad (DEF-01).
// Las tasas (RATE) se guardan como fracción: 0.10 = 10%.
export function formatParameterValue(value, unit) {
  if (value === null || value === undefined || value === '') return '—'
  const n = Number(value)
  const num = (x, dec) => x.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec })
  switch (unit) {
    case 'PEN':         return 'S/ ' + num(n, 2)
    case 'RATE':        return parseFloat((n * 100).toFixed(4)) + '%'
    case 'UITS':        return parseFloat(n.toFixed(4)) + ' UIT'
    case 'DAYS':        return parseFloat(n.toFixed(4)) + ' días'
    case 'HOURS':       return parseFloat(n.toFixed(4)) + ' h'
    case 'DAILY_WAGES': return parseFloat(n.toFixed(4)) + ' jornales'
    case 'FACTOR':      return num(n, 2)
    case 'FLAG':        return n === 1 ? 'Aplica' : 'No aplica'
    default:            return String(parseFloat(n.toFixed(4)))
  }
}

export function formatIsoDate(iso) {
  if (!iso) return ''
  const [y, m, d] = String(iso).split('-')
  return `${d}/${m}/${y}`
}

export const REGIME_LABELS = {
  GENERAL: 'General',
  MYPE_PEQUENA: 'MYPE pequeña',
  MYPE_MICRO: 'MYPE micro',
  AGRARIO: 'Agrario',
  CONSTRUCCION: 'Construcción',
  HOGAR: 'Hogar',
}
